import { render, staticRenderFns } from "./FootballStats2.vue?vue&type=template&id=88eafafe&scoped=true&"
import script from "./FootballStats2.vue?vue&type=script&lang=js&"
export * from "./FootballStats2.vue?vue&type=script&lang=js&"
import style0 from "./FootballStats2.vue?vue&type=style&index=0&id=88eafafe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eafafe",
  null
  
)

export default component.exports